import EmployeeHero from "./EmployeeHero";
import EmployeeService from "./EmployeeService";
import EmployeeBenefits from "./EmployeeBenefits";
import EmployeeKeyBenefits from "./EmployeeKeybenefits";
import EmployeeEmpowerment from "./EmployeeEmpowerment";

const Employee = () => {
  return (
    <>
      <EmployeeHero />
      <EmployeeService />
      <EmployeeBenefits />
      <EmployeeKeyBenefits />
      <EmployeeEmpowerment />
    </>
  );
};

export default Employee;
